import { Form, Formik } from 'formik'
import { ListGroup, ListGroupItem } from 'reactstrap'
import { LoaderButton } from 'components/molecules'
import PropTypes from 'prop-types'
import ProductPerPageFilterField from 'domains/product/organisms/paging-filter-field/product-per-page-filter-field'
import MarketingDiscountBatchStatusField from './marketing-discount-batch-status-field'
import MarketingDiscountBatchCodeField from './marketing-discount-batch-code-field'
import MarketingDiscountBatchStartField from './marketing-discount-batch-start-field'
import MarketingDiscountBatchExpiredField from './marketing-discount-batch-expired-field'

const propTypes = {
  initialFilters        : PropTypes.object,
  handleSubmitForm      : PropTypes.func.isRequired,
  perPage               : PropTypes.string.isRequired,
  handlePerPageOnChange : PropTypes.func.isRequired
}

const defaultProps = {
  initialFilters        : { },
  handleSubmitForm      : () => { },
  perPage               : '10',
  handlePerPageOnChange : () => { }
}

const MarketingDiscountBatchFilterForm = ({
  initialFilters,
  handleSubmitForm,
  perPage,
  handlePerPageOnChange
}) => {
  const initialValues = {
    status              : initialFilters?.status || '',
    code                : initialFilters?.code || '',
    start_batch_job_at  : initialFilters?.start_batch_job_at || '',
    expire_batch_job_at : initialFilters?.expire_batch_job_at || '',
    page                : initialFilters?.page || 1,
    per_page            : initialFilters?.per_page || 10
  }

  return (
    <Formik
      initialValues={ initialValues }
      onSubmit={ handleSubmitForm }
      enableReinitialize={ true }
    >
      {
        (formik) => (
          <Form>
            <ListGroup>
              <ListGroupItem>
                <ProductPerPageFilterField
                  perPage={ perPage }
                  handlePerPageOnChange={ handlePerPageOnChange }
                />
              </ListGroupItem>

              <ListGroupItem>
                <MarketingDiscountBatchStatusField/>
              </ListGroupItem>

              <ListGroupItem>
                <MarketingDiscountBatchCodeField/>
              </ListGroupItem>

              <ListGroupItem>
                <MarketingDiscountBatchStartField/>
              </ListGroupItem>

              <ListGroupItem>
                <MarketingDiscountBatchExpiredField/>
              </ListGroupItem>

              <div className='d-flex justify-content-center position-sticky fixed-bottom bg-white py-3'>
                <LoaderButton
                  className='float-right'
                  color='primary'
                  type='submit'
                  disabled={ formik.isSubmitting }
                  isLoading={ formik.isSubmitting }
                  text={ 'SEARCH' }
                />
              </div>

            </ListGroup>
          </Form>
        )
      }

    </Formik>
  )
}

MarketingDiscountBatchFilterForm.propTypes    = propTypes
MarketingDiscountBatchFilterForm.defaultProps = defaultProps

export default MarketingDiscountBatchFilterForm
